<!--

UN-USED action toolbar for an old "pdf builder" feature.  DO NOT LOOK AT THIS ONE!

The ACTUAL actual toolbar is in:  src/components/Widgets/DraftEditor/ActionsOld.vue

-->
<template>
  <div ref="actionBar">
    <div class="editor-actions">
      <base-button
        :disabled="disabled"
        inverse
        nowrap
        block
        @click.native="prompt_email()"
      >
        <span v-if="emailEngine.status == 'sending'">
          <font-awesome-icon
            :icon="['fas', 'spinner']"
            spin
          />
          Sending {{ emailEngine.name }}
        </span>
        <span v-else>
          <base-icon icon="send-email-inverse" />
          Send {{ emailEngine.name }}
        </span>
      </base-button>

      <base-button
        ref="save_button"
        :disabled="disabled"
        block
        gray
        @click.native="preview"
      >
        <base-icon
          icon="preview"
          class="mr-1"
        />Preview
      </base-button>

      <base-button
        :disabled="disabled"
        nowrap
        block
        gray
        @click.native="prompt_test()"
      >
        <base-icon
          icon="send-test"
          class="mr-1"
        />Send Test
      </base-button>

      <hr>

      <base-button
        :disabled="disabled"
        block
        nowrap
        gray
        @click.native="linkFormat = 'html'; openLinkModal();"
      >
        <font-awesome-icon icon="clipboard" />&nbsp;Create Link
      </base-button>
      <base-button
        v-if="beta"
        :disabled="disabled"
        block
        nowrap
        gray
        @click.native="linkFormat = 'pdf'; openLinkModal();"
      >
        <base-icon
          icon="save-pdf"
          class="mr-1"
        />Save as PDF
      </base-button>
    </div>

    <validation-observer
      ref="form"
      v-slot="{ invalid }"
    >
      <base-confirm-dialog
        v-if="confirm_test === true"
        message="Sent test to:"
        positive-text="Send"
        :disabled="invalid"
        @confirmed="send_test()"
        @cancelled="confirm_test = false"
      >
        <form
          data-vv-scope="test-form"
          class="needs-validation"
          novalidate
        >
          <div class="mb-3">
            <!-- First Name: -->
            <validation-provider
              ref="test_first_name_provider"
              v-slot="{ invalid }"
              name="name"
              rules="required"
            >
              <input
                ref="test_first_name"
                v-model="test_first_name"
                type="text"
                :class="`form-control ${ invalid ? 'is-invalid' : ''}`"
                name="test_first_name"
              >
            </validation-provider>
          </div>
          <div class="mb-3">
            <!-- Email: -->
            <validation-provider
              ref="test_email_provider"
              v-slot="{ invalid }"
              name="email"
              rules="required|email"
            >
              <input
                ref="test_email"
                v-model="test_email"
                type="email"
                :class="`form-control ${ invalid ? 'is-invalid' : ''}`"
                name="test_email"
              >
            </validation-provider>
          </div>
        </form>
      </base-confirm-dialog>
    </validation-observer>

    <base-confirm-dialog
      v-if="confirm_email"
      message="Are you sure you want to send?"
      positive-text="Send"
      @confirmed="sendMail()"
      @cancelled="confirm_email = false"
    />

    <base-confirm-dialog
      v-if="$store.state.entries.emailStatus == 'sent' || $store.state.entries.gmailStatus == 'sent'"
      message="Your email was sent"
      :show-close-button="false"
      :show-cancel="false"
      @confirmed="updateStatus(); $router.push('/entries')"
    />

    <base-confirm-dialog
      v-if="$store.state.entries.emailStatus == 'sent_test' || $store.state.entries.gmailStatus == 'sent_test'"
      message="Your test email was sent"
      :show-close-button="false"
      :show-cancel="false"
      @confirmed="updateStatus();"
    />

    <base-confirm-dialog
      v-if="$store.state.entries.emailStatus == 'error' || $store.state.entries.gmailStatus == 'error'"
      :message="$store.state.entries.emailStatusMessage || 'There was an error sending your email. Please try again.'"
      :show-actions="!$store.state.entries.emailStatusMessage"
      :show-close-button="$store.state.entries.emailStatusMessage"
      positive-text="Send another edit"
      @cancelled="updateStatus()"
      @confirmed="updateStatus(); $router.push('/entries')"
    />
    <link-creation-modal
      :show="linkModal"
      :edit="item.pk"
      :display="linkFormat"
      @close-link-modal="onCloseLinkModal"
    />
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { EventBus } from '@/event-bus';
import { entryService, linksService } from '@/_services';
import LinkCreationModal from './LinkCreationModal';

export default {
  name: 'Actions',

  components: {
    LinkCreationModal,
    ValidationObserver,
    ValidationProvider,
  },

  props: {
    recipientsCount: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      beta: true, // Transition
      confirm_email: false,
      confirm_test: false,
      test_first_name: null,
      test_email: null,
      linkModal: false,
      linkFormat: undefined,
    };
  },
  computed: {
    item() {
      return this.$store.state.entries.item;
    },
    disabled() {
      return this.$store.state.sections.isLoading || ['saving', 'loading'].includes(this.patchStatus);
    },
    patchStatus() {
      return this.$store.state.entries.status;
    },
    emailEngine() {
      const useGmail = this.useFeature('send_gmail');
      return {
        name: useGmail ? 'Gmail' : 'Email',
        action: useGmail ? this.loginGmail : this.send,
        status: useGmail
          ? this.$store.state.entries.gmailStatus
          : this.$store.state.entries.emailStatus,
      };
    },
    profileEmail() {
      return this.$store.state.account.user.user.email;
    },
  },
  methods: {
    preview() {
      this.$router.push({ name: 'PageEditorPreview' });
    },
    viewPDF() {
      // const new_url = 'https://us-central1-html2pdf-256812.cloudfunctions.net/http/535/';

      linksService.createLink(this.item.pk, 'pdf').then((response) => {
        const { url } = response.data;
        try {
          window.Clipboard.copy(url);
          window.open(url);
        } catch (e) {
          EventBus.$emit('toast-error', 'Couldn\'t copy link, please wait a few seconds and try again.');
        }
      });
    },
    send_test() {
      // Send test using current email engine
      this.confirm_test = false;
      this.emailEngine.action({
        test_email: this.test_email,
        test_first_name: this.test_first_name,
      });
    },
    prompt_email() {
      if (this.recipientsCount === 0) {
        EventBus.$emit('toast-error', 'Select at least one recipient to receive Edit. Add groups or customers to the “To:” section and try again.');
        return;
      }
      this.$refs.actionBar.click();
      this.confirm_email = true;
    },
    prompt_test() {
      const alertMessage = 'Please write a subject';
      const subject = this.item.subject.replace(/<\/?[^>]+(>|$)/g, '');
      if (!subject || subject.length === 0) {
        EventBus.$emit('toast-error', alertMessage);
        return;
      }
      if (!this.test_email || !this.test_email.length) {
        this.test_email = this.$store.state.account.user.user.email;
        this.test_first_name = this.$store.state.account.user.user.first_name;
      }
      this.confirm_test = true;
    },
    sendMail() {
      this.confirm_email = false;
      return this.emailEngine.action();
    },
    updateStatus() {
      this.$store.commit('entries/updateEmailStatus', null, null);
      this.$store.commit('entries/updateGmailStatus', null, null);
      this.$store.commit('entries/updateEmailStatusMessage', null, null);
    },
    async loginGmail(test_payload = {}) {
      const r = await entryService.checkGmailAuth();
      let authCode = null;
      if (!r.data.already_authed) {
        authCode = await this.$gAuth.getAuthCode();
      }
      await this.$store.dispatch('entries/sendGmail', {
        authCode,
        test_payload,
      });
    },
    send(test_payload = {}) {
      const alertMessage = 'Please write a subject';
      if (!this.item.subject) {
        EventBus.$emit('toast-error', alertMessage);
        return;
      }
      const isTest = Object.keys(test_payload).length > 0;
      if (this.recipientsCount === 0 && !isTest) {
        EventBus.$emit('toast-error', 'Select at least one recipient to receive Edit. Add groups or customers to the “To:” section and try again.');
        return;
      }

      const subject = this.item.subject.replace(/<\/?[^>]+(>|$)/g, '');

      if (subject.length > 0) {
        this.$store.dispatch('entries/sendEmail', test_payload);
      } else {
        EventBus.$emit('toast-error', alertMessage);
      }
    },
    openLinkModal() {
      this.linkModal = true;
    },
    onCloseLinkModal() {
      this.linkModal = false;
      EventBus.$emit('restart-recipients-customers');
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .base-button{
  height: 35px;
}
</style>
